import { memo } from 'react'
import { ButtonBase } from '@mui/material'

import { usePackageInfo } from '@/utils'
import { HamburgerIcon } from '@/assets'
import { Box } from '@/components/Layout'

import { navigationMenuClasses } from '../NavigationMenu/NavigationMenu.data'
import { useNavigationMenuController } from '../NavigationMenu/NavigationMenu.controller'

import NavigationDrawer from './NavigationDrawer/NavigationDrawer'
import { mobileNavigationMenuStyles as styles } from './NavigationMenuMobile.styles'

const MobileNavigationMenu = () => {
  const { isInsidePackageFlow } = usePackageInfo()
  const { isDrawerNavigationOpen, toggleNavigationDrawer } = useNavigationMenuController()

  if (isInsidePackageFlow) return null

  return (
    <Box sx={styles.wrapper}>
      <ButtonBase onClick={() => toggleNavigationDrawer(true)}>
        <HamburgerIcon className={navigationMenuClasses.hamburgerMenuIcon} />
      </ButtonBase>

      <NavigationDrawer
        isDrawerOpen={isDrawerNavigationOpen}
        toggleDrawer={toggleNavigationDrawer}
      />
    </Box>
  )
}

export default memo(MobileNavigationMenu)
